var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGlobeorange = function SvgGlobeorange(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#FE7C11",
    rx: 4
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#fff",
    strokeWidth: 1.5,
    clipPath: "url(#globeorange_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.003 18.666a6.667 6.667 0 1 0 0-13.333 6.667 6.667 0 0 0 0 13.333Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.003 18.666c1.472 0 2.666-2.984 2.666-6.666s-1.194-6.667-2.666-6.667c-1.473 0-2.667 2.985-2.667 6.667s1.194 6.666 2.667 6.666Z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M5.336 12h13.333"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "globeorange_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M4 4h16v16H4z"
  })))));
};
export default SvgGlobeorange;